import { isMockMode, post, simulateDelay } from "../api";

export interface DeleteUpdateCustomDataRequest {
	customDataId: number;
	name?: string;
	description?: string;
	data?: string;
	executionPriority?: number;
	isEnabled?: boolean;
	isDeleted?: boolean;
}

export const deleteUpdateCustomData = (
	data: DeleteUpdateCustomDataRequest,
	isDelete = false
) => {
	data.isDeleted = isDelete;

	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(1000, () => testData);
	}

	return post("CustomData/Update", data, {
		successMessage:
			isDelete === true
				? "Custom data successfully deleted"
				: isDelete === false
				? "Custom data successfully updated"
				: null,
	});
};
